export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const FILE_SIZE_UNITS = ["Bytes", "KB", "MB", "GB"] as const;
export const BYTES_PER_UNIT = 1024;